import React, { useState, useEffect, useCallback} from 'react';
import PageContainer from '../../../CSIComponents/PageContainer'
import { Card, Form, Row, Col, Select, Button } from 'antd';
import Grid from '@material-ui/core/Grid';
import styles from '../index.module.css'
import ActionButtonsBar from '../../../ui/ActionButtonsBar'
import Input from '../../../ui/Input'
import { getUniqueRoomData, postUniqueRoom } from './helper'
import Loading from '../../../Loading'

const UniqueRoomAmenitie = (props: any) => {

  const [disabledStatus, setDisabledStatus] = useState(true);
  const [outletVoltageOptions] = useState(['110 AC', '220 AC'])
  const [pillowOptions] = useState(['Fiber Filled', 'Down Filled', 'Down Alternative', 'Memory Foam', 'Feather Filled'])
  const [uniqueData, setUniqueData] = useState<any>({})
  const [ready, setReady] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [form] = Form.useForm();
  const editCancelClik = () => props.setOperation('table')

  const editSaveFinish = async () => {
    setReady(false)
    const body = form.getFieldsValue()
    if (props.currentRow && props.currentRow?.grid && props.currentRow?.grlangid) {
      const { grid, grlangid } = props.currentRow
      const res: any = await postUniqueRoom({
        grid,
        grlangid,
        ...body
      })

      const filter = res?.property?.guestrooms.guestroom.filter((res: any) => res.grid === props.currentRow?.grid)

      setUniqueData(filter)
    } 

    if (props.roomId && props.roomLangId) {
      const res: any = await postUniqueRoom({
        grid: props.roomId,
        grlangid: props.roomLangId,
        ...body
      })

      const filter = res?.property?.guestrooms.guestroom.filter((res: any) => res.grid === props.roomId)

      setUniqueData(filter)
    }

    // setIsEdit(false)
    setDisabledStatus(true)
    return setReady(true)
  }

  const Option = Select.Option;

  const getData = useCallback(async () => {
    setUniqueData(props.currentRow)
    setReady(true)
  },[])

  const editButton = (
    <Button type="primary" onClick={() => setIsEdit(true)} className="db-edit-btn" style={{ width: 90 }}>Edit</Button>
  )
  const backButton = (
      <Button onClick={() => editCancelClik()} style={{marginRight: 10}}>Back</Button>
  )

  const onFieldsChange = () => {
    const v = form.getFieldsError()
      .filter(({ errors }: { errors: any }) => errors.length).length;
    if (v === 0) {
      setDisabledStatus(false)
    } else {
      setDisabledStatus(true)
    }
  }

  useEffect(() => {
    getData()
  },[getData])

  useEffect(() => {
    setIsEdit(true)
  }, [])
  
  return (
    <PageContainer >
      <Card style={{ marginBottom: 60, marginTop: -15}}>
        <Grid container spacing={0} className='containerSpacing py-0'>
          <Grid item xs={12} className='p-0'>
            <div className={styles.roomTypeHeaderLine}>
              <section style={{ fontWeight: 'bold' }}>Unique Room Amenities</section>
              {/* CNT-2340
                <section className={isEdit ? 'hide' : ''}>
                  {backButton}
                  {editButton}
                </section> 
              */}
            </div>
            { ready ?
            <Form
              layout="vertical"
              form={form}
              name="basic"
              initialValues={uniqueData}
              className={isEdit ? '' : 'is-disabled-fields'}
              onFieldsChange={onFieldsChange}
            >
              <Row gutter={24}>
                <Col span={7} className="col-margin" >
                    <Form.Item
                        label="Closets In Room"
                        name={['uniqueamenities', "closetinroom"]}
                        rules={[{
                          pattern: /^[0-9]\d*$/,
                          message: 'This field should be a number'
                          },{ 
                            max: 5,
                            message: 'You have reached the max character length of 5' 
                          }
                        ]}
                    >
                        <Input maxLength={5} edit={isEdit}/>
                    </Form.Item>
                </Col>
                <Col span={7} className="col-margin">
                    <Form.Item
                        label="Outlet Voltage"
                        name={['uniqueamenities', "outletvoltage"]}
                    >
                        <Select allowClear showSearch>
                            {
                                outletVoltageOptions.map((item: string, i: number) => {
                                    return <Option key={i} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={7} className="col-margin">
                    <Form.Item
                        label="Safe Charge"
                        name={['uniqueamenities', "safecharge"]}
                        rules={[{
                          pattern: /^[-+]?[0-9]*\.?[0-9]*$/, 
                          message: 'This field should be a number' 
                          },{ 
                            max: 6,
                            message: 'You have reached the max character length of 6' 
                          }
                        ]}
                    >
                        <Input maxLength={6} edit={isEdit}/>
                    </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={7} className="col-margin" >
                    <Form.Item
                        label="Television Size"
                        name={['uniqueamenities', "televisionsize"]}
                        rules={[{
                          // pattern: /^[0-9!"\$%\^\&*\)\(+=._-]+$/g,
                          pattern: /^[0-9]\d*$/,
                          message: 'This field should be a number'
                          },{ 
                            max: 5,
                            message: 'You have reached the max character length of 5' 
                          }
                        ]}
                    >
                        <Input maxLength={5} edit={isEdit}/>
                    </Form.Item>
                </Col>
                <Col span={7} className="col-margin">
                    <Form.Item
                        label="Bed Linen Thread Count"
                        name={['uniqueamenities', "bedlinenthread"]}
                        rules={[
                          { 
                            pattern: /^[0-9]\d*$/, 
                            message: 'This field should be a number' 
                          },
                          { 
                            max: 4,
                            message: 'You have reached the max character length of 4' 
                          }
                        ]}
                    >
                        <Input maxLength={4} edit={isEdit}/>
                    </Form.Item>
                </Col>
                <Col span={7} className="col-margin">
                    <Form.Item
                        label="Pillow Type"
                        name={['uniqueamenities', "pillowtype"]}
                    >
                        <Select allowClear showSearch>
                            {
                                pillowOptions.map((item: string, i: number) => {
                                    return <Option key={i} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
              <Col span={7} className="col-margin" >
                  <Form.Item
                      label="Number of telephones in a majority of the rooms"
                      name={['uniqueamenities', "telephoneinmajorroom"]}
                      rules={[
                        { 
                          pattern: /^[0-9]\d*$/, 
                          message: 'This field should be a number' 
                        },
                        { 
                          max: 5,
                          message: 'You have reached the max character length of 5' 
                        }
                      ]}
                  >
                      <Input maxLength={5} edit={isEdit}/>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            : 
            <Row gutter={24}>
              <div style={{ height: 100 }}>
                <Loading type="large" />
              </div>
            </Row>
            }
          </Grid>
        </Grid>
        <div className="roomType-unique">
          <ActionButtonsBar
            onDelete={false}
            // onCancel={() => { setIsEdit(false); setReady(false); form.resetFields(); getData() }}
            onSave={editSaveFinish}
            disabledSave={disabledStatus}
            show={isEdit}
          /> 
        </div>
      </Card>
    </PageContainer>
  )
}

export default UniqueRoomAmenitie
